module.exports = __webpack_public_path__ + "static/media/web.e27613ba.png";